import _ from 'lodash';
angular
    .module("skillBuilderSaaS")
    .factory("_", function () {
    return _;
});
